var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertisement"},_vm._l((_vm.advertLists),function(item,index){return _c('div',{key:item.id},[_c('img',{attrs:{"src":item.images,"alt":""},on:{"click":function($event){return _vm.advertCenter(index)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }